// djin-cloud/web/src/theme/gamma-echarts-theme.ts

export const gammaEChartsTheme = {
  color: ['#34d399', '#38bdf8', '#fbbf24', '#fb7185', '#a78bfa', '#06b6d4'],
  backgroundColor: 'transparent',
  textStyle: {
    fontFamily: 'Inter, system-ui, sans-serif',
    color: '#94a3b8',
  },
  title: {
    textStyle: {
      color: '#e2e8f0',
      fontFamily: 'Inter, system-ui, sans-serif',
      fontWeight: 600,
      fontSize: 14,
    },
  },
  legend: {
    textStyle: {
      color: '#94a3b8',
      fontFamily: 'Inter, system-ui, sans-serif',
      fontSize: 12,
    },
  },
  tooltip: {
    backgroundColor: '#111d2e',
    borderColor: 'rgba(52, 211, 153, 0.12)',
    borderWidth: 1,
    textStyle: {
      color: '#e2e8f0',
      fontFamily: 'Inter, system-ui, sans-serif',
      fontSize: 12,
    },
    extraCssText: 'border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.3);',
  },
  categoryAxis: {
    axisLine: { lineStyle: { color: 'rgba(52, 211, 153, 0.12)' } },
    axisTick: { lineStyle: { color: 'rgba(52, 211, 153, 0.12)' } },
    axisLabel: {
      color: '#64748b',
      fontFamily: 'Inter, system-ui, sans-serif',
      fontSize: 11,
    },
    splitLine: { lineStyle: { color: 'rgba(52, 211, 153, 0.06)' } },
  },
  valueAxis: {
    axisLine: { lineStyle: { color: 'rgba(52, 211, 153, 0.12)' } },
    axisTick: { lineStyle: { color: 'rgba(52, 211, 153, 0.12)' } },
    axisLabel: {
      color: '#64748b',
      fontFamily: "'JetBrains Mono', 'SF Mono', monospace",
      fontSize: 11,
    },
    splitLine: { lineStyle: { color: 'rgba(52, 211, 153, 0.06)' } },
  },
  timeAxis: {
    axisLine: { lineStyle: { color: 'rgba(52, 211, 153, 0.12)' } },
    axisTick: { lineStyle: { color: 'rgba(52, 211, 153, 0.12)' } },
    axisLabel: {
      color: '#64748b',
      fontFamily: "'JetBrains Mono', 'SF Mono', monospace",
      fontSize: 11,
    },
    splitLine: { lineStyle: { color: 'rgba(52, 211, 153, 0.06)' } },
  },
  dataZoom: {
    backgroundColor: '#0d1520',
    dataBackgroundColor: 'rgba(52, 211, 153, 0.1)',
    fillerColor: 'rgba(52, 211, 153, 0.08)',
    handleColor: '#34d399',
    handleSize: '80%',
    textStyle: { color: '#94a3b8' },
    borderColor: 'rgba(52, 211, 153, 0.12)',
  },
  toolbox: {
    iconStyle: {
      borderColor: '#64748b',
    },
    emphasis: {
      iconStyle: {
        borderColor: '#34d399',
      },
    },
  },
};

// Color constants for direct use in chart options
export const GAMMA_COLORS = {
  green: '#34d399',
  blue: '#38bdf8',
  yellow: '#fbbf24',
  red: '#fb7185',
  purple: '#a78bfa',
  cyan: '#06b6d4',
  textPrimary: '#e2e8f0',
  textSecondary: '#94a3b8',
  textMuted: '#64748b',
  border: 'rgba(52, 211, 153, 0.12)',
  gridLine: 'rgba(52, 211, 153, 0.06)',
} as const;
